import { memo } from "react";

const ActionSend = (props: any) => (
  <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.9171 2.0835L12.3754 17.9168L9.20874 10.7918L2.08374 7.62516L17.9171 2.0835Z"
      stroke="currentColor"
      strokeWidth="1.40351"
      strokeLinejoin="round"
    />
    <path
      d="M17.9173 2.0835L9.20898 10.7918"
      stroke="currentColor"
      strokeWidth="1.40351"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(ActionSend);
